module.exports = __webpack_public_path__ + "img/logo.db371d2d.png";